import { EnumJoinStatus, EnumMoreOptions, EnumTongHaoStatus } from '@xt/client/enums/kindred-spirit'
import { MomentSourceType } from '@xt/client/enums/moment'

export const dataSource_tonghao = [
  {
    key: EnumTongHaoStatus.Follow,
    title: '关注',
    params: {}
  },
  {
    key: EnumTongHaoStatus.Discover,
    title: '发现',
    params: {
      topic: '笔墨点亮生活,好作业,学习感悟,回后山,小食光,暄桐雅会,桐学雅会'
    }
  },
  {
    key: EnumTongHaoStatus.FenTong,
    title: '桐学会',
    params: {
      sourceType: MomentSourceType.Guild
    }
  },
  {
    key: EnumTongHaoStatus.InkLightUpLife,
    title: '笔墨点亮生活',
    params: {
      topic: '笔墨点亮生活'
    }
  },
  {
    key: EnumTongHaoStatus.GoodHomework,
    title: '好作业',
    params: {
      topic: '好作业'
    }
  },
  {
    key: EnumTongHaoStatus.StudyInsight,
    title: '学习感悟',
    params: {
      topic: '学习感悟'
    }
  },
  {
    key: EnumTongHaoStatus.BackToHoushan,
    title: '回后山',
    params: {
      topic: '回后山'
    }
  },
  {
    key: EnumTongHaoStatus.SnackTime,
    title: '小食光',
    params: {
      topic: '小食光'
    }
  },
  { key: EnumTongHaoStatus.XuantongGathering, title: '暄桐雅集', params: { topic: '暄桐雅会' } },
  { key: EnumTongHaoStatus.ClassmateGathering, title: '桐学雅会', params: { topic: '桐学雅会' } },
  { key: EnumTongHaoStatus.ClassmateWork, title: '桐学作品', params: { topic: '桐学作品' } }
]

export const dataSource_topicManagerFilter = [
  { key: '', label: '全部' },
  { key: EnumJoinStatus.Join, label: '待入群' },
  { key: EnumJoinStatus.Exit, label: '待退出' }
]

export const dataSource_topicMoreOpions = [
  {
    key: EnumMoreOptions.List,
    label: '更多分桐'
  },
  {
    key: EnumMoreOptions.Manager,
    label: '分桐管理'
  },
  {
    key: EnumMoreOptions.Exit,
    label: '退出分桐'
  },
  {
    key: EnumMoreOptions.CancelExit,
    label: '取消退出'
  }
]

export const dataSource_hide_store_key: {
  hideCitiesStoreKey: string
  hideLocationTipStoreKey: string
  hideImproveModalStoreKey: string
} = {
  hideCitiesStoreKey: 'hide-recommend-cities',
  hideLocationTipStoreKey: 'hide-location-tip',
  hideImproveModalStoreKey: 'hide-improve-tip'
}

// 城市列表展示的全部省份数据
export const dataSource_all_cities = [
  {
    parent: {
      name: '北京',
      adcode: '110000'
    },
    list: []
  },
  {
    parent: {
      name: '天津',
      adcode: '120000'
    },
    list: []
  },
  {
    parent: {
      name: '河北',
      adcode: '130000'
    },
    list: []
  },
  {
    parent: {
      name: '山西',
      adcode: '140000'
    },
    list: []
  },
  {
    parent: {
      name: '内蒙古',
      adcode: '150000'
    },
    list: []
  },
  {
    parent: {
      name: '辽宁',
      adcode: '210000'
    },
    list: []
  },
  {
    parent: {
      name: '吉林',
      adcode: '220000'
    },
    list: []
  },
  {
    parent: {
      name: '黑龙江',
      adcode: '230000'
    },
    list: []
  },
  {
    parent: {
      name: '上海',
      adcode: '310000'
    },
    list: []
  },
  {
    parent: {
      name: '江苏',
      adcode: '320000'
    },
    list: []
  },
  {
    parent: {
      name: '浙江',
      adcode: '330000'
    },
    list: []
  },
  {
    parent: {
      name: '安徽',
      adcode: '340000'
    },
    list: []
  },
  {
    parent: {
      name: '福建',
      adcode: '350000'
    },
    list: []
  },
  {
    parent: {
      name: '江西',
      adcode: '360000'
    },
    list: []
  },
  {
    parent: {
      name: '山东',
      adcode: '370000'
    },
    list: []
  },
  {
    parent: {
      name: '河南',
      adcode: '410000'
    },
    list: []
  },
  {
    parent: {
      name: '湖北',
      adcode: '420000'
    },
    list: []
  },
  {
    parent: {
      name: '湖南',
      adcode: '430000'
    },
    list: []
  },
  {
    parent: {
      name: '广东',
      adcode: '440000'
    },
    list: []
  },
  {
    parent: {
      name: '广西',
      adcode: '450000'
    },
    list: []
  },
  {
    parent: {
      name: '海南',
      adcode: '460000'
    },
    list: []
  },
  {
    parent: {
      name: '重庆',
      adcode: '500000'
    },
    list: []
  },
  {
    parent: {
      name: '四川',
      adcode: '510000'
    },
    list: []
  },
  {
    parent: {
      name: '贵州',
      adcode: '520000'
    },
    list: []
  },
  {
    parent: {
      name: '云南',
      adcode: '530000'
    },
    list: []
  },
  {
    parent: {
      name: '西藏',
      adcode: '540000'
    },
    list: []
  },
  {
    parent: {
      name: '陕西',
      adcode: '610000'
    },
    list: []
  },
  {
    parent: {
      name: '甘肃',
      adcode: '620000'
    },
    list: []
  },
  {
    parent: {
      name: '青海',
      adcode: '630000'
    },
    list: []
  },
  {
    parent: {
      name: '宁夏',
      adcode: '640000'
    },
    list: []
  },
  {
    parent: {
      name: '新疆',
      adcode: '650000'
    },
    list: []
  },
  {
    parent: {
      name: '台湾',
      adcode: '710000'
    },
    list: []
  },
  {
    parent: {
      name: '香港',
      adcode: '810000'
    },
    list: []
  },
  {
    parent: {
      name: '澳门',
      adcode: '820000'
    },
    list: []
  }
]
